export default __webpack_public_path__ + "static/media/jackpot.479baeb4.svg";